import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Applicationstatus, ApplicationstatusMaintanence } from './applicationstatus.model';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApplicationstatusService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService) { }
  create(payload: Applicationstatus): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/applicationstatus');
      let bodyContent = {"applicationstatus":payload};
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
 
  findByKey(key: Applicationstatus): FindByKeyFn<Applicationstatus|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applicationstatus/{appRef}/{processCode}');
       httpRequest.addPathParameter('appRef', key.appRef);
       httpRequest.addPathParameter('processCode', key.processCode);
       httpRequest.setServerContext(environment.customersPublisher);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.applicationstatus ?? null),catchError((err:any) => {
              return of(null)
            }));
        
    };
  }

  modify(payload: Applicationstatus): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applicationstatus/{appRef}/{processCode}');
       httpRequest.addPathParameter('appRef', payload.appRef);
       httpRequest.addPathParameter('processCode', payload.processCode);
       httpRequest.setServerContext(environment.customersPublisher);

     httpRequest.setMethod('PUT');
      let bodyContent = {"applicationstatus":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
  
  //  patch(payload: Applicationstatus): PatchFn<any> {
  //   return () => {
  //     const httpRequest = new HttpRequest();
  //     httpRequest.setResource('/applicationstatus/{appRef}/{processCode}');
  //      httpRequest.addPathParameter('appRef', payload.appRef);
  //      httpRequest.addPathParameter('processCode', payload.processCode);
  //    httpRequest.setMethod('PUT');
  //     let bodyContent = {"applicationstatus":payload};
  //     httpRequest.setBody(bodyContent);
  //     return this._httpProvider.invokeRestApi(httpRequest);
  //   };
  // }
  findAll(criteriaQuery: CriteriaQuery): FindAllFn<Applicationstatus[]> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/carddetails');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      httpRequest.setServerContext(environment.customersPublisher);

      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res) =>
              res.body.carddetails
          )
        );
    };
  }
  
   
     lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/Applicationstatus');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
	  httpCriteria.setPaginationCriteria('1', 10);
	  httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
	  searchText: key.searchText ?? '',
	  });
	  httpRequest.setCriteriaQuery(httpCriteria);
 
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
   
  // response = {
  //   "applicationstatus":{
  //   "lastName":"Gayathri",
  //   "mobile":"9848022372",
  //   "authOn":"2023-08-0215:10:43",
  //   "createdOn":"2023-08-0215:10:43",
  //   "firstName":"rajan",
  //   "inventoryNumber":"20230802151043014787",
  //   "requestRef":"",
  //   "appRef":"C2023011224",
  //   "processCode":"CARDAPPLSTS",
  //   "obRefNum":"998751de-4ed6-4fbe-aefe-56392282fb94",
  //   "requestDate":"",
  //   "appStatusDesc":"ResumeApplication",
  //   "middleName":"",
  //   "email":"sivamani72@gmail.com",
  //   "status":"Resume"
  //   }
  //   };
  getApplicationStatus(processId:string): Observable<any> {
    // return of(this.response);

    const httpRequest = new HttpRequest();
    httpRequest.setResource('/applicationstatus/{processId}');
    httpRequest.addPathParameter('processId', processId);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.customersPublisher);
    
    return this._httpProvider
      .invokeRestApi(httpRequest) // res.body.docgroup.docgroupdtl // this.response.docgroup.docgroupdtl
      .pipe(map((res: IHttpSuccessPayload<any>) => res.body ?? null), catchError((err: any) => {
        return of(null)
      }));
  }
}
